<template>
  <div id="app" class="fullheight">
    <router-view></router-view>
  </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/services/firebase'
import { mapFields } from 'vuex-map-fields'
import Dashboard from '@/components/Dashboard'

export default {
  components: {
    Dashboard
  },
  computed: {
    ...mapFields([
      'userfirstname',
      'userlastname',
      'useremail',
      'usercolor',
      'userlevel',
      'userTwilioAccountSID',
      'teamTwilioAccountSID',
      'teamTwilioAuthToken',
      'teamTwilioSMSNumber',
      'teamname',
      'teamlastupdate',
      'teamlastcommfrom',
      'forceConversationUpdate',
      'globalcontacthistory'
    ])
  },
  beforeCreate () {
    var self = this
    self.forceConversationUpdate = false
    self.globalcontacthistory = []
    self.globalcontacthistorywithnames = []
    if (firebase.auth().currentUser) {
      self.userdata = firebase.auth().currentUser
      db.collection('users').doc(self.userdata.email).get().then(function (doc) {
        if (doc.exists) {
          self.userfirstname = doc.data().firstname
          self.userlastname = doc.data().lastname
          self.useremail = self.userdata.email
          self.usercolor = doc.data().color
          self.userlevel = doc.data().level
          self.userTwilioAccountSID = doc.data().TwilioAccountSID
          console.log('---------- Data loaded for user: ' + self.useremail)
          self.loadTeam(self.userTwilioAccountSID)
        } else {
          console.log('Doc does not exist at ' + self.useremail)
        }
      })
    } else {
      console.log('unauthed')
      console.log(self.$route)
      if (self.$route.params.number) {
        var rightnow = Math.floor(Date.now() / 1000)
        console.log('Created UpdateNotice: ' + rightnow)
        console.log(self.$route.params.number)
        db.collection('teams').doc(self.$route.params.sid).update({
          teamlastcommfrom: self.$route.params.number,
          teamlastupdate: rightnow
        }).catch(error => {
          console.log('-----error-------')
          console.log(error)
        })
      }
    }
  },
  methods: {
    loadTeam: function (tsid) {
      var self = this
      db.collection('teams').doc(tsid).get().then(function (doc) {
        if (doc.exists) {
          self.teamTwilioAuthToken = doc.data().TwilioAuthToken
          self.teamTwilioSMSNumber = doc.data().TwilioSMSNumber
          self.teamTwilioAccountSID = doc.data().TwilioAccountSID
          self.teamlastupdate = doc.data().teamlastupdate
          self.teamlastcommfrom = doc.data().teamlastcommfrom
          self.teamname = doc.data().teamname
          console.log('------------- Team Configuration loaded!')
          db.collection('teams').doc(tsid).onSnapshot({
            includeMetadataChanges: true
          }, function (doc) {
            self.teamlastupdate = doc.data().teamlastupdate
            self.teamlastcommfrom = doc.data().teamlastcommfrom
            self.$store.dispatch('getContactHistory')
          })
        } else {
          console.log('Team does not exist at ' + tsid)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
  // primary: md-get-palette-color(deeppurple, 500), // The primary color of your application
  // accent: md-get-palette-color(blue, 600) // The accent or secondary color
));

@import "~vue-material/dist/theme/all"; // Apply the theme

  .fullheight {
    min-height: 100vh;
    max-height: 100vh;
    max-width: 1200px;
    margin: auto;
  }
  body {
    background-color: #999999;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue